/**
 * FIREFOX COMPATIBILITY FIX
 * Patch existing LazyImage to handle Firefox loading issues
*/

document.addEventListener('DOMContentLoaded', () => {
    // Override the existing handleLazy method
    const originalHandleLazy = LazyImage.prototype.handleLazy;
    
    LazyImage.prototype.handleLazy = function() {
        if (this.classList.contains("loaded")) return;
        
        // Firefox fix: Check if image is already complete
        if (this.complete && this.naturalHeight !== 0) {
            const finishLoading = () => {
                this.classList.add("loaded");
                this.media.classList.remove("loading");
            };
            setTimeout(finishLoading, 0);
            return;
        }
        
        // Call original method
        originalHandleLazy.call(this);
        
        // Firefox fallback timeout
        if (!this.complete) {
            setTimeout(() => {
                if (this.complete && this.naturalHeight !== 0 && 
                    !this.classList.contains("loaded")) {
                    const finishLoading = () => {
                        this.classList.add("loaded");
                        this.media.classList.remove("loading");
                    };
                    setTimeout(finishLoading, 0);
                }
            }, 0);
        }
    };
});